import { Component } from '@angular/core';
import { AuthService } from './services';

@Component({
  selector: 'app-root',
  template: '<app-pages></app-pages>',
})
export class AppComponent {

  constructor(
    private authService: AuthService
  ){

    this.authService.isLoggedIn();
  }
}
